import createEnum from 'scripts/lib/create_enum';
import createModel, { prop } from 'models/lib/create_model';

export const ExternalCustomerLookupStatusValue = createEnum('DISABLED', 'NOT_CONFIGURED', 'OK');

const ExternalCustomerLookupStatus = createModel({
  modelName: 'ExternalCustomerLookupStatus',
  properties: {
    name: prop(String),
    status: prop(String).default(ExternalCustomerLookupStatusValue.NOT_CONFIGURED),
    hasConnector: prop(Boolean).default(false),
    basicDisabled: prop(Boolean).default(false),
    autoLinkingEnabled: prop(Boolean).default(false),
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export default ExternalCustomerLookupStatus;



// WEBPACK FOOTER //
// ./src/scripts/domain/models/external_customer_lookup_status.js